import {
  initCardinalService,
  handleBinDeviceDetection
} from './utils/cardinal-utils';

const cardinalService = async ({ order: orderDetails, tdsProviderDetails }) => {
  await initCardinalService(orderDetails);

  return {
    submitTdsTransaction: handleBinDeviceDetection(orderDetails, tdsProviderDetails.threeDsByPassOnProviderFailure)
  };
};

export default cardinalService;
